import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { Drawer } from 'rsuite'
import { LoaderBtn } from '../Loader/Loader-btn'
import 'rsuite/dist/rsuite.css'

function FicheDrawerComposant(props) {
  const { t } = useTranslation()
  const titleFiche = props.isEdit ? props.titleEdit : props.titleNew

  return (
    <Drawer
      className={props.className}
      open={props.show}
      onClose={props.onClose}
      size={props.size ?? 'lg'}
      style={props.style}
    >
      <Drawer.Header style={props.drawerHeaderStyle}>
        <Drawer.Title style={props.titleStyle}>
          {props.title ?? titleFiche}
          {props?.download_viewer}
        </Drawer.Title>
        <Drawer.Actions>
          {props.urlBack && (
            <Link to={props.urlBack}>
              <Button
                variant="outline-primary"
                style={{ margin: '0px 0px 0px 10px' }}
                className="primary-outline-button"
              >
                {t('cash.settings.SmartTags.fiche.buttons.back')}
              </Button>
            </Link>
          )}
          {props.isLinkDrawerFrorecast && props.isViewModeForecast && (
            <Button
              variant="primary"
              className="primary-button"
              style={{ margin: '0px 0px 0px 10px' }}
              onClick={() => props.createForecast()}
            >
              {props.loaderCreate ? <LoaderBtn /> : t('New')}
            </Button>
          )}

          {!props.isViewMode && (
            <Button
              variant="primary"
              className="primary-button"
              style={{ margin: '0px 0px 0px 10px' }}
              onClick={() =>
                props.isEdit ? props.updateFuction() : props.createFuction()
              }
            >
              {props.loaderCreate ? (
                <LoaderBtn />
              ) : (
                t('cash.settings.SmartTags.fiche.buttons.save')
              )}
            </Button>
          )}
        </Drawer.Actions>
      </Drawer.Header>

      <Drawer.Body style={{ padding: props.noPadding ? '0px' : '30px' }}>
        <>
          {props.dataLoading && (
            <div
              className="position-absolute d-flex align-items-center justify-content-center w-100 h-100"
              style={{
                zIndex: 99,
                backgroundColor: 'rgba(255, 255, 255, 0.5)',
                maxWidth: 'calc(100% - 20px)',
                color: '#d3014c',
              }}
            >
              <div>
                <span className="fa fa-spinner fa-spin fa-3x" />
              </div>
            </div>
          )}
          {props.cardBody}
        </>
      </Drawer.Body>
    </Drawer>
  )
}
export default FicheDrawerComposant

